// import { useContext, useState } from "react";
// import { Navbar, Container } from "react-bootstrap";
// import "./BusinessGroupForm.css"; // Import custom CSS
// import { AppThemeContext } from "../../../../../context/AppThemeContext";
// import { BaseUrl } from "../../../../../api/AxiosApi";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
// import Modal from "react-bootstrap/Modal";

// function BusinessGroupForm({ show, handleClose }) {
//     const User_ID = sessionStorage.getItem("LOGIN_ID")
//     const { PrimaryColor } = useContext(AppThemeContext);
//     const [formData, setFormData] = useState({
//         groupName: "",
//         groupAddress: "",
//         email: "",
//         password: "",

//     });

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prevData) => ({
//             ...prevData,
//             [name]: value,
//         }));
//     };


//     console.log("formdata", User_ID)

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const queryParams = new URLSearchParams({
//                 Group_Name: formData.groupName,
//                 Address: formData.groupAddress,
//                 Mail_ID: formData.email,
//                 Password: formData.password,
//                 SKey: "XYZ"
//             }).toString();

//             const formBody = new URLSearchParams({
//                 USER_ID:"SunGreen GREEN CLEAN",
//                 Group_ID: "",
//                 TYPE_ID:"I"
//             }).toString();

//             const finalUrl = `${BaseUrl}CMN_10_Update/iGroup?${queryParams}`;
//             console.log("API URL:", finalUrl);

//             const response = await fetch(finalUrl, {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/x-www-form-urlencoded", // ✅ Correct header
//                 },
//                 body: formBody
//             });

//             console.log("API Response:", response);

//             if (!response.ok) {
//                 throw new Error("Failed to create user");
//             }

//             // const result = await response.json();
//             // console.log("API Response Data:", result);

//             const rawResponse = await response.text();
//             console.log("Raw API Response:", rawResponse); // ✅ पहले इसे print करें

//             const result = JSON.parse(rawResponse);
//             console.log("API Response Data:", result);


//             if (result.success) {
//                 setFormData({
//                     groupName: "",
//                     groupAddress: "",
//                     email: "",
//                     password: ""
//                 });
//             }

//         } catch (error) {
//             console.error("Error creating user:", error);
//         }
//     };




//     return (
//         <>

//             <Modal show={show} onHide={handleClose} centered>
//                 <Modal.Header closeButton className="modal-header-custom" style={{ backgroundColor: PrimaryColor }}>
//                     <Modal.Title>Add Group Details</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <Form onSubmit={handleSubmit}>
//                         <div className="row">
//                             <div className="col-md-12">
//                                 <Form.Group className="mb-3">
//                                     <Form.Label>Group/Company Name</Form.Label>
//                                     <Form.Control type="text" name="groupName" value={formData.groupName} onChange={handleChange} />
//                                 </Form.Group>
//                             </div>



//                             <div className="col-md-12">
//                                 <Form.Group className="mb-3">
//                                     <Form.Label>Group/Company Address</Form.Label>
//                                     <Form.Control type="text" name="groupAddress" value={formData.groupAddress} onChange={handleChange} />
//                                 </Form.Group>
//                             </div>


//                             <div className="col-md-12">
//                                 <Form.Group className="mb-3">
//                                     <Form.Label>Email</Form.Label>
//                                     <Form.Control type="text" name="email" value={formData.email} onChange={handleChange} />
//                                 </Form.Group>
//                             </div>


                            

//                             <div className="col-md-12">
//                                 <Form.Group className="mb-3">
//                                     <Form.Label>Password</Form.Label>
//                                     <Form.Control type="text" name="password" value={formData.password} onChange={handleChange} />
//                                 </Form.Group>
//                             </div>


//                         </div>

//                         <Modal.Footer>
//                             <Button onClick={handleClose} style={{ backgroundColor: PrimaryColor }}>
//                                 Cancel
//                             </Button>
//                             <Button type="submit" style={{ backgroundColor: PrimaryColor }}>
//                                 Add Group
//                             </Button>
//                         </Modal.Footer>
//                     </Form>
//                 </Modal.Body>
//             </Modal>



//         </>
//     );
// }

// export default BusinessGroupForm;




// 2.

// // import { useContext, useState } from "react";
// // import { Navbar, Container } from "react-bootstrap";
// // import "./BusinessGroupForm.css"; // Custom CSS
// // import { AppThemeContext } from "../../../../../context/AppThemeContext";
// // import { BaseUrl } from "../../../../../api/AxiosApi";
// // import Button from "react-bootstrap/Button";
// // import Form from "react-bootstrap/Form";
// // import Modal from "react-bootstrap/Modal";

// // function BusinessGroupForm({ show, handleClose }) {
// //     // SessionStorage या LocalStorage से Dynamic USER_ID लें
// //     const User_ID = sessionStorage.getItem("LOGIN_ID") || "";
// //     const { PrimaryColor } = useContext(AppThemeContext);
// //     const [loading, setLoading] = useState(false);

// //     const [formData, setFormData] = useState({
// //         groupName: "",
// //         groupAddress: "",
// //         email: "",
// //         password: "",
// //     });

// //     const handleChange = (e) => {
// //         const { name, value } = e.target;
// //         setFormData((prevData) => ({
// //             ...prevData,
// //             [name]: value,
// //         }));
// //     };

// //     const handleSubmit = async (e) => {
// //         e.preventDefault();
// //         setLoading(true);

// //         try {
// //             // 1. यदि कोई वैल्यू खाली है तो '-' सेट करें (Postman Match)
// //             const groupNameVal = formData.groupName.trim();
// //             const addressVal = formData.groupAddress.trim() !== "" ? formData.groupAddress.trim() : "-";
// //             const emailVal = formData.email.trim() !== "" ? formData.email.trim() : "-";
// //             const passwordVal = formData.password.trim() !== "" ? formData.password.trim() : "-";

// //             // 2. URL Query String निर्माण
// //             const queryParams = new URLSearchParams({
// //                 Group_Name: groupNameVal,
// //                 Password: passwordVal,
// //                 Mail_ID: emailVal,
// //                 Address: addressVal,
// //                 SKey: "XYZ"
// //             });

// //             // 3. Postman Body Params (x-www-form-urlencoded)
// //             const formBody = new URLSearchParams();
// //             formBody.append("USER_ID", User_ID);
// //             formBody.append("Group_ID", "");
// //             formBody.append("TYPE_ID", "I");

// //             const finalUrl = `${BaseUrl}CMN_10_Update/iGroup?${queryParams.toString()}`;
// //             console.log("Sending URL:", finalUrl);
// //             console.log("Sending USER_ID:", User_ID);

// //             // 4. API Request
// //             const response = await fetch(finalUrl, {
// //                 method: "POST",
// //                 headers: {
// //                     "Content-Type": "application/x-www-form-urlencoded"
// //                 },
// //                 body: formBody // URLSearchParams ऑब्जेक्ट पास करें
// //             });

// //             const rawResponse = await response.text();
// //             console.log("Raw API Response:", rawResponse);

// //             let result;
// //             try {
// //                 result = JSON.parse(rawResponse);
// //             } catch (err) {
// //                 console.error("JSON Parse Error:", err);
// //             }

// //             // 5. Success Check Logic
// //             // API Response: { success: true, count: 1, data: "1", responseCode: "200" }
// //             if (
// //                 result &&
// //                 (result.success === true || result.success === "true") &&
// //                 (result.data === "1" || result.count > 0 || result.responseCode === "200")
// //             ) {
// //                 if (result.count === 0 || result.data === "0") {
// //                     // अगर API Response में count: 0 आ रहा है
// //                     alert("Group could not be added. Please verify if Group Name already exists or USER_ID is valid.");
// //                 } else {
// //                     alert("Business Group successfully added!");

// //                     // फॉर्म डेटा रीसेट करें
// //                     setFormData({
// //                         groupName: "",
// //                         groupAddress: "",
// //                         email: "",
// //                         password: ""
// //                     });

// //                     handleClose(); // Modal बंद करें
// //                 }
// //             } else {
// //                 alert("Failed to add Business Group! Please check inputs.");
// //             }

// //         } catch (error) {
// //             console.error("Error creating group:", error);
// //             alert("Network Error! Please check server logs.");
// //         } finally {
// //             setLoading(false);
// //         }
// //     };

// //     return (
// //         <Modal show={show} onHide={handleClose} centered>
// //             <Modal.Header closeButton className="modal-header-custom" style={{ backgroundColor: PrimaryColor }}>
// //                 <Modal.Title>Add Group Details</Modal.Title>
// //             </Modal.Header>
// //             <Modal.Body>
// //                 <Form onSubmit={handleSubmit}>
// //                     <div className="row">
// //                         <div className="col-md-12">
// //                             <Form.Group className="mb-3">
// //                                 <Form.Label>Group/Company Name *</Form.Label>
// //                                 <Form.Control 
// //                                     type="text" 
// //                                     name="groupName" 
// //                                     value={formData.groupName} 
// //                                     onChange={handleChange} 
// //                                     required
// //                                 />
// //                             </Form.Group>
// //                         </div>

// //                         <div className="col-md-12">
// //                             <Form.Group className="mb-3">
// //                                 <Form.Label>Group/Company Address</Form.Label>
// //                                 <Form.Control 
// //                                     type="text" 
// //                                     name="groupAddress" 
// //                                     value={formData.groupAddress} 
// //                                     onChange={handleChange} 
// //                                 />
// //                             </Form.Group>
// //                         </div>

// //                         <div className="col-md-12">
// //                             <Form.Group className="mb-3">
// //                                 <Form.Label>Email</Form.Label>
// //                                 <Form.Control 
// //                                     type="text" 
// //                                     name="email" 
// //                                     placeholder="Enter email or leave blank / -"
// //                                     value={formData.email} 
// //                                     onChange={handleChange} 
// //                                 />
// //                             </Form.Group>
// //                         </div>

// //                         <div className="col-md-12">
// //                             <Form.Group className="mb-3">
// //                                 <Form.Label>Password</Form.Label>
// //                                 <Form.Control 
// //                                     type="password" 
// //                                     name="password" 
// //                                     placeholder="Enter password or leave blank / -"
// //                                     value={formData.password} 
// //                                     onChange={handleChange} 
// //                                 />
// //                             </Form.Group>
// //                         </div>
// //                     </div>

// //                     <Modal.Footer>
// //                         <Button onClick={handleClose} variant="secondary" disabled={loading}>
// //                             Cancel
// //                         </Button>
// //                         <Button 
// //                             type="submit" 
// //                             disabled={loading}
// //                             style={{ backgroundColor: PrimaryColor, borderColor: PrimaryColor }}
// //                         >
// //                             {loading ? "Adding..." : "Add Group"}
// //                         </Button>
// //                     </Modal.Footer>
// //                 </Form>
// //             </Modal.Body>
// //         </Modal>
// //     );
// // }

// // export default BusinessGroupForm;

// // 3.

import { useContext, useState } from "react";
import { Navbar, Container } from "react-bootstrap";
import "./BusinessGroupForm.css"; // Custom CSS
import { AppThemeContext } from "../../../../../context/AppThemeContext";
import { BaseUrl } from "../../../../../api/AxiosApi";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";

function BusinessGroupForm({ show, handleClose }) {
    // SessionStorage या LocalStorage से Dynamic USER_ID लें
    const User_ID =localStorage.getItem("business_LOGIN_ID") || "";
    const { PrimaryColor } = useContext(AppThemeContext);
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        groupName: "",
        groupAddress: "",
        email: "",
        password: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            // 1. यदि कोई वैल्यू खाली है तो '-' सेट करें (Postman Match)
            const groupNameVal = formData.groupName.trim();
            const addressVal = formData.groupAddress.trim() !== "" ? formData.groupAddress.trim() : "-";
            const emailVal = formData.email.trim() !== "" ? formData.email.trim() : "-";
            const passwordVal = formData.password.trim() !== "" ? formData.password.trim() : "-";

            // 2. URL Query String निर्माण
            const queryParams = new URLSearchParams({
                Group_Name: groupNameVal,
                Password: passwordVal,
                Mail_ID: emailVal,
                Address: addressVal,
                SKey: "XYZ"
            });

            // 3. Postman Body Params (x-www-form-urlencoded)
            const formBody = new URLSearchParams();
            formBody.append("USER_ID", User_ID);
            formBody.append("Group_ID", "");
            formBody.append("TYPE_ID", "I");

            const finalUrl = `${BaseUrl}CMN_10_Update/iGroup?${queryParams.toString()}`;
            console.log("Sending URL:", finalUrl);
            console.log("Sending USER_ID:", User_ID);

            // 4. API Request
            const response = await fetch(finalUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: formBody
            });

            const rawResponse = await response.text();
            console.log("Raw API Response:", rawResponse);

            let result;
            try {
                result = JSON.parse(rawResponse);
            } catch (err) {
                console.error("JSON Parse Error:", err);
            }

            // 5. Success Check Logic
            if (
                result &&
                (result.success === true || result.success === "true") &&
                (result.data === "1" || result.count > 0 || result.responseCode === "200")
            ) {
                if (result.count === 0 || result.data === "0") {
                    alert("Group could not be added. Please verify if Group Name already exists or USER_ID is valid.");
                } else {
                    alert("Business Group successfully added!");

                    // फॉर्म डेटा रीसेट करें
                    setFormData({
                        groupName: "",
                        groupAddress: "",
                        email: "",
                        password: ""
                    });

                    handleClose(); // Modal बंद करें
                }
            } else {
                alert("Failed to add Business Group! Please check inputs.");
            }

        } catch (error) {
            console.error("Error creating group:", error);
            alert("Network Error! Please check server logs.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton className="modal-header-custom" style={{ backgroundColor: PrimaryColor }}>
                <Modal.Title>Add Group Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* autoComplete="off" ब्राउज़र को Saved Credentials ऑटो-फ़िल करने से रोकता है */}
                <Form onSubmit={handleSubmit} autoComplete="off">
                    <div className="row">
                        <div className="col-md-12">
                            <Form.Group className="mb-3">
                                <Form.Label>Group/Company Name *</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="groupName" 
                                    value={formData.groupName} 
                                    onChange={handleChange} 
                                    required
                                    autoComplete="off"
                                />
                            </Form.Group>
                        </div>

                        <div className="col-md-12">
                            <Form.Group className="mb-3">
                                <Form.Label>Group/Company Address</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="groupAddress" 
                                    value={formData.groupAddress} 
                                    onChange={handleChange} 
                                    autoComplete="off"
                                />
                            </Form.Group>
                        </div>

                        <div className="col-md-12">
                            <Form.Group className="mb-3">
                                <Form.Label>Email</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="email" 
                                    placeholder=""
                                    value={formData.email} 
                                    onChange={handleChange} 
                                    autoComplete="off"
                                />
                            </Form.Group>
                        </div>

                        <div className="col-md-12">
                            <Form.Group className="mb-3">
                                <Form.Label>Password</Form.Label>
                                <Form.Control 
                                    type="password" 
                                    name="password" 
                                    placeholder=""
                                    value={formData.password} 
                                    onChange={handleChange} 
                                    autoComplete="new-password"
                                />
                            </Form.Group>
                        </div>
                    </div>

                    <Modal.Footer>
                        <Button onClick={handleClose} variant="secondary" disabled={loading}>
                            Cancel
                        </Button>
                        <Button 
                            type="submit" 
                            disabled={loading}
                            style={{ backgroundColor: PrimaryColor, borderColor: PrimaryColor }}
                        >
                            {loading ? "Adding..." : "Add Group"}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default BusinessGroupForm;